export const getErrorMessage = (obj: any): any => {
  const firstKey = Object.keys(obj)[0];
  const item = obj[firstKey];
  if (typeof item === 'object') return getErrorMessage(item);
  return item;
};
